import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconSearchSvg } from "./IconSearchSvg.mjs";
const IconSearch = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconSearchSvg, ...iconProps });
};
export {
  IconSearch
};
